import axios from "axios";
import {API_DOMAIN} from "../constants";

const GROUPS_URL = API_DOMAIN + "/api/v3/auth/groups";

const authHeader = () => ({Authorization: localStorage.getItem("MFE_TOKEN")});

// GET /api/v3/auth/groups
// Returns [{id, name, description, claimCount, userCount}], ordered by name.
export async function getGroups() {
    const response = await axios({
        url: GROUPS_URL,
        method: "GET",
        headers: authHeader(),
    });

    return response.data;
}

// GET /api/v3/auth/groups?userTypeId=&businessUnitCode=&includeClaims=true  (TMMFX-2170 Change 4)
// Returns the groups available for a (user type, business unit), each as
// {id, name, description, claimCount, userCount, isDefault, claims: [{claimType, claimValue, displayName, categoryId}]}.
export async function getAvailableGroups(userTypeId, businessUnitCode) {
    const response = await axios({
        url: GROUPS_URL,
        method: "GET",
        headers: authHeader(),
        params: {userTypeId, businessUnitCode, includeClaims: true},
    });

    return response.data;
}

// GET /api/v3/auth/groups/{id}
// Returns {id, name, description, userCount, claims: [{claimType, claimValue, displayName, categoryId}]}.
export async function getGroup(id) {
    const response = await axios({
        url: `${GROUPS_URL}/${id}`,
        method: "GET",
        headers: authHeader(),
    });

    return response.data;
}

// POST /api/v3/auth/groups  (Global Admin)
// Payload: {name, description, claims?: [{claimType, claimValue}]} — the optional claims seed the
// new group's permissions (copy-from). Returns the summary shape. 409 if the name is already in
// use, 400 (with the offending entries) if any seed claim is unknown.
export async function createGroup(payload) {
    const response = await axios({
        url: GROUPS_URL,
        method: "POST",
        headers: authHeader(),
        data: payload,
    });

    return response.data;
}

// PUT /api/v3/auth/groups/{id}  (Global Admin)
// Payload: {name, description}. Permissions are managed via the group-claims endpoint, not here.
// Returns the summary shape. 409 if the name is already in use, 404 if unknown.
export async function updateGroup(id, payload) {
    const response = await axios({
        url: `${GROUPS_URL}/${id}`,
        method: "PUT",
        headers: authHeader(),
        data: payload,
    });

    return response.data;
}

// DELETE /api/v3/auth/groups/{id}  (Global Admin)
// 204 on success. 409 if the group is still assigned to users, 404 if unknown.
export async function deleteGroup(id) {
    return axios({
        url: `${GROUPS_URL}/${id}`,
        method: "DELETE",
        headers: authHeader(),
    });
}
